/**
 * Gift short codes, as they arrive in a URL.
 *
 * Shared by the public claim page (`components/qrCodeClaimPage.js`) and the staging redirect
 * (`components/stagingQrRedirect.js`) so both read a code out of a query string the same way.
 */

/**
 * Strip the wrapping braces some senders' links carry (`{YON10KCV}`) and trim whitespace.
 *
 * Returns `""` for anything falsy, so callers can treat "no code" as one case.
 */
export function normalizeShortCode(raw) {
  if (!raw) return "";
  return raw.replace(/^\{|\}$/g, "").trim();
}

/**
 * Is this plausibly a gift code?
 *
 * Codes are short alphanumeric strings (`YON10KCV`, `8UCVVKDR`). The check is deliberately loose —
 * it exists to catch a code that could only ever fail, not to enforce a format the backend owns.
 * Anything with a `:` or `/` in it is certainly not a code, which is what keeps a URL in the query
 * string from being treated as one.
 */
export function isPlausibleShortCode(code) {
  return /^[A-Za-z0-9_-]{1,64}$/.test(code);
}
